// Nivo's line-drawing prop only accepts a flat lineWidth number, no per-series
// dash pattern — so an "actual vs. projected" (or "value vs. reference")
// distinction needs its own layer rather than a style prop. Draws each serie
// as its own contiguous run of defined points (skipping nulls, same gap
// behavior as the default layer), dashed when the serie carries `dashed: true`.
const DashAwareLines = ({ series, lineGenerator, lineWidth }) => (
  <g>
    {series.map(serie => {
      const runs = [];
      let current = [];
      serie.data.forEach(d => {
        if (d.data.y === null || d.data.y === undefined) {
          if (current.length) { runs.push(current); current = []; }
        } else {
          current.push(d.position);
        }
      });
      if (current.length) runs.push(current);
      return runs.map((run, i) => (
        <path
          key={`${serie.id}.${i}`}
          d={lineGenerator(run)}
          fill="none"
          stroke={serie.color}
          strokeWidth={lineWidth}
          strokeDasharray={serie.dashed ? '6,4' : undefined}
        />
      ));
    })}
  </g>
);

export default DashAwareLines;
